var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"3"}},[_c('p',[_vm._v("DENNA SIDA ÄR UNDER KONSTRUKTION")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }